import React from 'react';
import propTypes from 'prop-types';

export const OnlinePaymentIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      enableBackground="new 0 0 512 512"
    >
      <g>
        <g>
          <path d="m287.8,57.2l-230.1,223.7c-7.7,7.5-7.9,19.8-0.5,27.5l140,145.9c7.1,7.4 19.6,7.6 27,0.5l230.1-223.7c7.7-7.5 7.9-19.8 0.5-27.5l-140-145.9c-8-8-18.6-8.9-27-0.5zm-120.1,425.4l-140-145.9c-22.9-23.9-22.2-62 1.5-85.1l230.1-223.7c22.2-22.2 60.9-22.6 84.9,1.5l140,145.9c22.9,23.9 22.2,62-1.5,85.1l-230,223.7c-22.1,22-59.1,24.4-85-1.5z" />
          <path d="m153.4,342.8l13.9-13.6c2.4-2.3 4-4.1 4.8-5.2 1.4-2 2.3-3.9 2.8-5.7 0.5-1.8 0.4-3.8-0.2-5.9-0.6-2.1-1.7-4-3.5-5.8-2-2.1-4.3-3.4-6.9-3.9-2.6-0.5-5.1-0.2-7.6,1.1-2.5,1.2-5.5,3.6-9.1,7l-13,12.6 18.8,19.4zm-25-26l12.1-11.8c3.3-3.2 5.4-5.7 6.4-7.5 1.3-2.4 1.9-4.7 1.6-6.9-0.3-2.2-1.4-4.3-3.3-6.3-1.8-1.9-3.8-3.1-6.1-3.6-2.3-0.6-4.5-0.3-6.6,0.8-2.2,1.1-5.3,3.6-9.3,7.5l-11.2,10.9 16.4,16.9zm24,39.9l-54.1-56.4 21-20.4c4.3-4.2 8.3-6.9 11.9-8.3 3.7-1.4 7.4-1.6 11.1-0.6 3.7,0.9 6.9,2.7 9.3,5.3 2.3,2.4 3.8,5.3 4.6,8.7 0.7,3.4 0.4,7-0.9,10.9 4.3-2.3 8.6-3.1 12.7-2.5 4.1,0.6 7.8,2.6 10.9,5.9 2.5,2.6 4.3,5.6 5.4,9 1.1,3.3 1.4,6.4 0.9,9.2-0.4,2.8-1.6,5.7-3.5,8.7-1.9,3-4.6,6.3-8.1,9.7l-21.2,20.8z" />
          <path d="m192.7,272.8l19-18.5-20.8-9.9c-6.3-3-11.4-5.6-15.2-7.8 2.8,4.3 5.2,8.9 7.3,13.7l9.7,22.5zm6,38.8l-32.6-77.3 8-7.8 77,34.1-8.4,8.2-22.9-10.7-23.4,22.8 10.2,23.1-7.9,7.6z" />
          <polygon points="257,255 202.9,198.6 210.5,191.2 282.4,206.9 239.9,162.6 247,155.7 301.1,212.1 293.5,219.5 221.6,203.8     264.1,248.1 257,255   " />
          <polygon points="313.3,200.3 259.2,143.9 266.6,136.7 293.4,164.7 294.4,109.7 304.4,99.9 302.9,145.6 359.6,155.3 349.8,164.8     302.5,155.6 301.9,173.6 320.7,193.1 313.3,200.3   " />
          <path d="m225.7,410.9c-5.3,0-10.6-2.1-14.6-6.2-7.9-8.1-7.7-21 0.4-28.9l36.3-35.3c8.1-7.9 21-7.7 28.9,0.4 7.9,8.1 7.7,21-0.4,28.9l-36.3,35.3c-4.1,3.8-9.2,5.8-14.3,5.8z" />
        </g>
      </g>
    </svg>
  );
};
OnlinePaymentIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
OnlinePaymentIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
